import { render, staticRenderFns } from "./ConsultarCargo.vue?vue&type=template&id=af1c6f4c"
import script from "./ConsultarCargo.vue?vue&type=script&lang=js"
export * from "./ConsultarCargo.vue?vue&type=script&lang=js"
import style0 from "./ConsultarCargo.vue?vue&type=style&index=0&id=af1c6f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports